<template>
  <div id='box'>
    <nav class="navbar">
      <div class="logo">
        <img src="/imgs/home/images/header-logo.png" alt="">
      </div>
      <!-- 汉堡按钮 -->
      <div class="hamburger" @click="toggleDrawer">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <!-- 抽屉蒙层 -->
      <div class="drawer-mask" v-show="drawerOpen" @click="closeDrawer"></div>
      <!-- 抽屉导航 -->
      <transition name="slide">
        <div class="drawer" v-show="drawerOpen">
          <ul class="drawer-menu">
            <li><router-link to="/" @click.native="closeDrawer">{{ i18n[lang].home }}</router-link></li>
            <li><router-link to="/about" @click.native="closeDrawer">{{ i18n[lang].about }}</router-link></li>
            <li><router-link to="/services" @click.native="closeDrawer">{{ i18n[lang].services }}</router-link></li>
            <li><router-link to="/news" @click.native="closeDrawer">{{ i18n[lang].news }}</router-link></li>
            <li><router-link to="/contact" @click.native="closeDrawer">{{ i18n[lang].contact }}</router-link></li>
          </ul>
          <div class="drawer-lang">
            <img src="/imgs/home/images/header-cn_1.png" alt="CN" @click="setLang('CN')">
            <img src="/imgs/home/images/header-ru_03.png" alt="RU" @click="setLang('RU')">
            <img src="/imgs/home/images/header-en_03.png" alt="EN" @click="setLang('EN')">
          </div>
        </div>
      </transition>
      <!-- 桌面端导航 -->
      <ul class="nav-menu">
        <li><router-link to="/">{{ i18n[lang].home }}</router-link></li>
        <li><router-link to="/about">{{ i18n[lang].about }}</router-link></li>
        <li><router-link to="/services">{{ i18n[lang].services }}</router-link></li>
        <li><router-link to="/news">{{ i18n[lang].news }}</router-link></li>
        <li><router-link to="/contact">{{ i18n[lang].contact }}</router-link></li>
        <li class="lang-icons">
          <img src="/imgs/home/images/header-cn_1.png" alt="CN" @click="setLang('CN')">
          <img src="/imgs/home/images/header-ru_03.png" alt="RU" @click="setLang('RU')">
          <img src="/imgs/home/images/header-en_03.png" alt="EN" @click="setLang('EN')">
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  data () {
    return {
      drawerOpen: false,
      lang: 'CN',
      i18n: {
        CN: {
          home: '首页',
          about: '关于同升',
          services: '产品与服务',
          news: '公司动态',
          contact: '联系我们'
        },
        EN: {
          home: 'HOME',
          about: 'ABOUT US',
          services: 'PRODUCT AND SERVICE',
          news: 'NEWS',
          contact: 'CONTACT US'
        },
        RU: {
          home: 'Главная страница',
          about: 'О компании Tongsheng',
          services: 'Продукция и услуги',
          news: 'Новости компании',
          contact: 'Свяжитесь с нами'
        }
      }
    }
  },
  created () {
    const saved = localStorage.getItem('lang')
    if (saved) this.lang = saved
  },
  methods: {
    toggleDrawer () {
      this.drawerOpen = !this.drawerOpen
    },
    closeDrawer () {
      this.drawerOpen = false
    },
    setLang (code) {
      this.lang = code
      localStorage.setItem('lang', code)
      this.$emit('lang-change', code)
      location.reload()
    }
  }
}
</script>

<style scoped>
#box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 75px;
  padding: 0 10rem;
  position: relative;
}
.logo img {
  height: 48px;
}
.nav-menu {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 3rem;
}
.nav-menu li {
  display: flex;
  align-items: center;
}
.nav-menu a {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  transition: color .3s;
}
.nav-menu a:hover {
  color: #1890ff;
}
.lang-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}
.lang-icons img:first-child {
  width: 36px;
  height: 36px;
  cursor: pointer;
}
.lang-icons img {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

/* 汉堡按钮 */
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  cursor: pointer;
  gap: 6px;
}
.hamburger span {
  width: 24px;
  height: 2px;
  background: #333;
  transition: all .3s;
}

/* 抽屉蒙层 */
.drawer-mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.4);
  z-index: 98;
}

/* 抽屉 */
.drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  height: 100vh;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0,0,0,.15);
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 80px 24px 32px;
}
.drawer-menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
.drawer-menu li {
  margin-bottom: 24px;
}
.drawer-menu a {
  font-size: 18px;
  color: #333;
  text-decoration: none;
  display: block;
  padding: 12px 0;
  transition: color .3s;
}
.drawer-menu a:hover {
  color: #1890ff;
}
.drawer-lang {
  display: flex;
  gap: 12px;
}
.drawer-lang img {
  width: 24px;
  height: 16px;
  cursor: pointer;
}

/* 抽屉滑入动画 */
.slide-enter-active, .slide-leave-active {
  transition: transform .3s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .navbar {
    padding: 0 1rem;
  }
  .logo img {
    height: 36px;
  }
  .nav-menu {
    display: none;
  }
  .hamburger {
    display: flex;
  }
}
</style>